<div class="help-dialog-container">
  <h1 mat-dialog-title>Permissões do perfil {{ profile.name }}:</h1>
  <div mat-dialog-content cdkFocusInitial>
    <ul>
      <li *ngFor="let item of featuresToShow" class="help-item">{{ item }}</li>
    </ul>
  </div>
  <div mat-dialog-actions>
    <button (click)="onClick()" class="help-button">Ok</button>
  </div>
</div>
